// src/components/Insights/InsightsIndex.tsx
import { InsightPost } from "../../data/posts";

interface InsightsIndexProps {
  insights: InsightPost[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

const InsightsIndex: React.FC<InsightsIndexProps> = ({
  insights,
  selectedId,
  onSelect,
}) => {
  return (
    <div className="surface-card divide-y divide-line">
      {insights.map((insight) => {
        const isActive = insight.id === selectedId;
        return (
          <button
            key={insight.id}
            onClick={() => onSelect(insight.id)}
            type="button"
            className={`w-full text-left px-5 py-5 border-l-2 transition-colors ${
              isActive
                ? "bg-surface-2 border-signal"
                : "bg-transparent border-transparent hover:bg-surface-2 hover:border-line-strong"
            }`}
          >
            <p className={`kicker mb-1.5 ${isActive ? "text-signal" : ""}`}>
              {insight.tags[0] || "Insight"}
            </p>
            <h3 className="font-display text-sm sm:text-base font-semibold text-ink mb-1.5">
              {insight.title}
            </h3>
            <p className="font-mono text-xs text-muted mb-2 tracking-wide">
              {new Date(insight.date)
                .toLocaleDateString("en-GB", {
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                })
                .toUpperCase()}{" "}
              · {insight.readingTime.toUpperCase()}
            </p>
            <p className="text-xs text-muted line-clamp-3">
              {insight.excerpt}
            </p>
            <div className="flex flex-wrap gap-1.5 mt-3">
              {insight.tags?.slice(0, 4).map((tag) => (
                <span key={tag} className="tag-chip">
                  {tag}
                </span>
              ))}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default InsightsIndex;
